var styleDataHash = "11d27aff";
const injectCss = (() => {
  var css = `.fowRo{margin-left:0;margin-right:auto;z-index:1}.fowRo:not(.uyTwi){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.fowRo:not(.uyTwi){float:none;margin-right:auto}}}@container (width < 480px){.fowRo:not(.uyTwi){float:none;margin-right:auto}}.q5UqZ{margin-left:auto;margin-right:0;z-index:1}.q5UqZ:not(.uyTwi){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.q5UqZ:not(.uyTwi){float:none;margin-left:auto}}}@container (width < 480px){.q5UqZ:not(.uyTwi){float:none;margin-left:auto}}.eczFu{clear:both;display:block}.eczFu:not(.ElC5v){margin-left:auto;margin-right:auto;max-width:100%}.ElC5v,.uyTwi{width:100%}.BT6MC .ElC5v,.BT6MC .uyTwi{margin:0 -8px;width:auto}.jlAKg{width:fit-content}.KxPFs{margin-left:auto;margin-right:auto;max-width:100%}.Dad1T{width:min(350px,100%)!important}.BT6MC .Dad1T{width:50%}.GSYxa{margin-left:auto;margin-right:auto}.BT6MC .GSYxa{width:150px}.cyZtZ{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "alignLeft": "fowRo",
  "textWrapNowrap": "uyTwi",
  "alignRight": "q5UqZ",
  "alignCenter": "eczFu",
  "sizeFullWidth": "ElC5v",
  "renderedInTable": "BT6MC",
  "sizeOriginal": "jlAKg",
  "sizeContent": "KxPFs",
  "sizeSmall": "Dad1T",
  "sizeSmallCenter": "GSYxa",
  "flex": "cyZtZ"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
